import React from 'react';
import AppLayout from '../../layout/app.layout';
import ListChannels from '../../components/content/list-channels.component';

const ContentChannelsView = () => {
  const pageTitle = 'Analytics / Engagement / Views by App';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <ListChannels />
    </AppLayout>
  );
};

export default ContentChannelsView;
